export const USER_ROLES = ['USER', 'MODEL', 'ADMIN'];
export const ADMIN_PERMISSIONS = ['SUPER_ADMIN', 'TRUST_SAFETY', 'OPERATIONS'];
export const SHOW_TYPES = [
    'MAIN_STAGE',
    'PARTY',
    'TICKET',
    'CLUB',
    'VIP',
    'EXCLUSIVE',
    'PEEP',
];
export const SHOW_STATUSES = ['WAITING', 'LIVE', 'ENDED', 'PAUSED', 'AWAY'];
export const DEMAND_PRICING_MODES = ['OFF', 'SUGGEST', 'AUTO'];
export const DEMAND_LEVELS = ['DEAD', 'SLOW', 'NORMAL', 'ACTIVE', 'HOT', 'VIRAL'];
export const CHAT_RANKS = ['GRAY', 'GREEN', 'BLUE', 'PURPLE', 'GOLD', 'PLATINUM'];
export const EXPERIENCE_MODES = ['COMMUNITY', 'LIVE', 'VIDEOS'];
/** Inclusive discovery categories for the live/cams grid. */
export const MODEL_GENDERS = ['WOMAN', 'MAN', 'TRANS', 'COUPLE', 'NONBINARY'];
export const ROOM_GAME_TYPES = ['WHEEL', 'SLOT'];
export const SLOT_SYMBOLS = ['🍒', '🍋', '🔔', '⭐', '💎', '7️⃣'];
export const SLOT_MATCH_KINDS = ['NONE', 'PAIR', 'THREE', 'JACKPOT'];
export const APPS = ['consumer', 'studio', 'agency', 'partners', 'admin', 'create'];
export const ALPHA_INVITE_ROLES = ['FAN', 'MODEL', 'BOTH'];
export const ACCESS_TIERS = ['T0_DENY', 'T1_STANDARD', 'T2_ENHANCED', 'T3_STRICT_ID'];
export const ADULT_FEATURES = ['live', 'video', 'profile', 'messaging', 'purchase'];
export const AGE_VERIFICATION_STATUSES = [
    'NONE',
    'ATTESTED',
    'PENDING',
    'VERIFIED',
    'FAILED',
    'BLOCKED',
];
/** Local WebRTC mesh signaling (Socket.IO `stream.signal`). Not SFU. */
export const STREAM_SIGNAL_KINDS = [
    'publisher.ready',
    'viewer.hello',
    'offer',
    'answer',
    'ice',
    'health',
    'peer.left',
];
/** Second mesh channel for Exclusive cam-to-cam. Missing channel means `show`. */
export const STREAM_CHANNELS = ['show', 'c2c'];
export const STREAM_HEALTH_ISSUES = [
    'disconnected',
    'no-video',
    'frozen-video',
    'no-audio',
    'packet-loss',
    'low-bandwidth',
    'high-rtt',
];
/** Live closed captions from the broadcaster's mic (Web Speech → Socket.IO). */
export const SHOW_CAPTION_MAX_CHARS = 280;
export const SHOW_VIEWER_ROLES = ['VIEWER', 'PARTICIPANT', 'SPY'];
export const SPY_MODES = ['ONGOING', 'FLASH'];
export const SHOW_INTERACTION_KINDS = ['TIP_MENU', 'JUKEBOX'];
export const PRIVATE_SHOW_REQUEST_TYPES = ['VIP', 'EXCLUSIVE'];
export { DEFAULT_STOREFRONT_MODULES, DEFAULT_STOREFRONT_PALETTE, STOREFRONT_PALETTES, isStorefrontPalette, parseStorefrontModules, parseStorefrontPalette, } from './storefront-appearance.js';
export { DEFAULT_MODEL_ONBOARDING_STATUS, MODEL_ONBOARDING_CHECKLIST_KEYS, MODEL_ONBOARDING_CHECKLIST_STATUSES, MODEL_ONBOARDING_INTENTS, MODEL_ONBOARDING_STATUSES, MODEL_ONBOARDING_STEPS, MODEL_PARTNER_INVITE_MODES, canBroadcastOnboarding, emptyModelOnboardingState, isModelOnboardingIntent, isModelOnboardingStatus, isModelOnboardingStep, isModelPartnerInviteMode, parseModelOnboardingIntent, parseModelOnboardingStatus, parseModelOnboardingStep, parseModelPartnerInviteMode, } from './model-onboarding.js';
export { CLOSET_CATALOG, CLOSET_CATALOG_BY_KEY, CLOSET_CATALOG_KEYS, CLOSET_CATEGORIES, isClosetCatalogKey, } from './closet-catalog.js';
export const DEFAULT_MODEL_NOTIFICATION_SETTINGS = {
    modelLive: true,
    newContent: false,
    privateMessage: true,
};
export const REPORT_CATEGORIES = [
    'HARASSMENT',
    'SPAM',
    'UNDERAGE_SUSPICION',
    'SCAM',
    'OTHER',
];
export const REPORT_RESOLUTION_STATUSES = ['REVIEWING', 'RESOLVED', 'DISMISSED'];
export const CHAT_MESSAGE_KINDS = ['USER', 'SYSTEM', 'ENTRANCE', 'TIP'];
export const GRAY_CHAT_MODES = ['UNLIMITED', 'MESSAGE_CAP', 'DISABLED'];
export const CHAT_ACCESS_MODES = ['ALLOWED', 'DISABLED', 'MESSAGE_CAP', 'TIP_FIRST'];
export const CHAT_AUDIENCE_TIERS = [
    'GUEST',
    'NEVER_PURCHASED',
    'DORMANT',
    'NO_BALANCE',
    'HAS_BALANCE',
];
export const PRIVATE_CHAT_MESSAGE_KINDS = ['TEXT', 'IMAGE', 'STICKER', 'SYSTEM'];
export const MEDIA_ITEM_STATUSES = ['DRAFT', 'PUBLISHED', 'UNPUBLISHED'];
export const MEDIA_KINDS = ['CLIP', 'MOVIE', 'EPISODE', 'SHOW_RECORDING', 'SHOW_SNAPSHOT'];
export const CATALOG_MEDIA_KINDS = ['CLIP', 'MOVIE', 'EPISODE'];
export const PRIVATE_CAPTURE_MEDIA_KINDS = ['SHOW_RECORDING', 'SHOW_SNAPSHOT'];
export function isPrivateCaptureMediaKind(kind) {
    return kind === 'SHOW_RECORDING' || kind === 'SHOW_SNAPSHOT';
}
export function resolveStreamChannel(channel) {
    return channel === 'c2c' ? 'c2c' : 'show';
}
/** Public floors that allow paid snapshots / recordings. Not VIP or Exclusive. */
export const PUBLIC_CAPTURE_SHOW_TYPES = ['MAIN_STAGE', 'PARTY', 'TICKET', 'CLUB', 'PEEP'];
export function isPublicCaptureShowType(type) {
    return PUBLIC_CAPTURE_SHOW_TYPES.includes(type);
}
export const SHOW_SNAPSHOT_COINS = 10;
export const SHOW_PUBLIC_RECORDING_COINS = 50;
export const SHOW_PUBLIC_RECORDING_MAX_SECONDS = 300;
export const DEFAULT_COLLECTION_NAME = 'Saved';
export const USER_COLLECTION_ITEM_KINDS = ['MEDIA', 'SHOW'];
/** Turn-on preference option IDs (stable; labels via i18n). */
export const TURN_ON_GENDERS = ['woman', 'man', 'trans', 'couple', 'nonbinary'];
export const TURN_ON_AGE_GROUPS = ['18_20', '21_30', '31_40', '41_50', '51_plus'];
export const TURN_ON_ETHNICITIES = [
    'asian',
    'black',
    'latina',
    'middle_eastern',
    'mixed',
    'white',
    'other',
];
export const TURN_ON_BODY_TYPES = [
    'slim',
    'athletic',
    'average',
    'curvy',
    'bbw',
    'sbbw',
    'muscular',
];
/** Map turn-on gender prefs to ModelGender for cams filters. */
export function turnOnGenderToModelGender(gender) {
    switch (gender) {
        case 'woman':
            return 'WOMAN';
        case 'man':
            return 'MAN';
        case 'trans':
            return 'TRANS';
        case 'couple':
            return 'COUPLE';
        case 'nonbinary':
            return 'NONBINARY';
    }
}
export const MAX_MODEL_FAVORITES = 10;
/* ------------------------------------------------------------------ *
 * Community layer — generic user profiles, follows, favorites
 * ------------------------------------------------------------------ */
export const PROFILE_VISIBILITIES = ['PUBLIC', 'MEMBERS', 'FOLLOWERS'];
/** Max ranked favorites any user may keep (community top-N). */
export const MAX_USER_FAVORITES = 10;
/** Max characters allowed in a community post body. */
export const MAX_POST_BODY_LENGTH = 2000;
export const NOTIFICATION_EVENTS = [
    'modelLive',
    'newContent',
    'privateMessage',
    'tipsAndPurchases',
];
export const NOTIFICATION_CHANNELS = ['browser', 'email', 'sms'];
export const LEADERBOARD_LIMIT = 10;
export const LEADERBOARD_WINDOWS = ['all', 'week', 'month'];
export const BLOCK_VISIBILITIES = ['PUBLIC', 'FAN_CLUB', 'INVITE_ONLY'];
export const BLOCK_STATUSES = ['OPEN', 'BOOKED', 'COMPLETED', 'CANCELLED'];
export const DISCOUNT_KINDS = ['TIME_OF_DAY', 'GROUP', 'INDIVIDUAL', 'COUPON'];
// --- Mode Pass ---
export const MODE_PASS_TIERS = ['PLUS', 'PREMIUM'];
// --- Custom video orders ---
export const CUSTOM_VIDEO_STATUSES = [
    'REQUESTED',
    'QUOTED',
    'ACCEPTED',
    'IN_PROGRESS',
    'DELIVERED',
    'DECLINED',
    'CANCELLED',
    'EXPIRED',
];
//# sourceMappingURL=index.js.map